import React, { Component, Fragment } from 'react';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import intl from 'react-intl-universal';

export default class ConsentControl extends Component {
  state = {
    showModal: false,
  };

  componentDidMount = () => {
    // if the value is `true` from the persitOrganizer response then
    // then it means that the user has already accepted the consent and the control should not be displayed
    this.setState({ showModal: this.props.value === '' || this.props.value === 'false' ? true : false });
  };

  hideModal = () => {
    this.setState(prevState => ({ showModal: !prevState.showModal }), () => this.props.onChange({ target: { value: 'true' } }));
  };

  render() {
    const { displayText } = this.props;

    return (
      <Fragment>
        {this.state.showModal && (
          <ConfirmDialog
            open
            noCancel
            title={intl.get('consent.modalTitle')}
            confirmText={intl.get('consent.modalConfirm')}
            onConfirm={() => {
              this.hideModal();
            }}>
            <span>{displayText}</span>
          </ConfirmDialog>
        )}
      </Fragment>
    );
  }
}
